import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../redux/configureStore';
import getCashInData from '../../../../../../redux/fetchActions/legadoPage/cashinReportApp';
import SearchButton, {
  Loading,
} from '../../../../../../shared/components/buttons/SearchButton';
import Filter from '../../../../../../shared/components/Filter';
import Wrapper from '../../../../../../shared/components/Wrapper';
import SetMonthEnd from './components/SetMonthEnd';
import SetMonthInitial from './components/SetMonthInitial';
import SetPartner from './components/SetPartner';
import SetType from './components/SetType';

export function CashinFilter() {
  const dispatch = useDispatch();
  const [initial, setInitial] = useState('');
  const [end, setEnd] = useState('');
  const [type, setTypeOption] = useState('sintetico');

  const profileUserState = useSelector(
    (reducer: IReducer) => reducer.userProfile
  );
  const [partner, setPartner] = useState(String(profileUserState.partnerId));

  const SyntheticContext = useSelector(
    (reducer: IReducer) => reducer.cashInSynthetic
  );

  const analyticContext = useSelector(
    (reducer: IReducer) => reducer.cashInAnalytic
  );

  return (
    <Filter.Default>
      <Wrapper.Default isActive flexDirection="row">
        <SetPartner set={setPartner} info={partner} />
        <SetType set={setTypeOption} info={type} />
        <SetMonthInitial setDate={setInitial} date={initial} />
        <SetMonthEnd setDate={setEnd} date={end} />
      </Wrapper.Default>
      {SyntheticContext.isLoading || analyticContext.isLoading ? (
        <Loading justifyContent="center" />
      ) : (
        <SearchButton
          onClick={() => {
            dispatch(getCashInData(initial, end, type, partner));
          }}
          justifyContent="center"
          width="10rem"
        />
      )}
    </Filter.Default>
  );
}

export default CashinFilter;
